"use client";

import { useEffect, useState } from "react";

export function DropdownPositionSync() {
  const [bannerVisible, setBannerVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const banner = document.querySelector("[data-banner]");
      if (banner) {
        const bannerBottom = banner.getBoundingClientRect().bottom;
        setBannerVisible(bannerBottom > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (bannerVisible) {
      root.style.setProperty("--dropdown-top", "calc(3rem + 4.5rem)");
    } else {
      root.style.setProperty("--dropdown-top", "4.5rem");
    }
  }, [bannerVisible]);

  return null;
}
